import * as actionTypes from "../../constants/creditposting/actiontypes.js";

const initialState = {
   isLoggedIn: '',
   creditResultRecords: {
      records: [],
      recordsCount: 0
   },
   creditResultExportRecords: {
      csvdata: '',
      filename: '',
      recordsCount: 0,
      isExportSuccess: false,
      isExportRecord: false
   }
};

export const creditResultReducer = (state = initialState, action) => {
   switch (action.type) {
      case actionTypes.FETCH_CREDITS_RESULT_SUCCESS:
         return Object.assign({}, ...[state], { creditResultRecords: action.creditsResult });
      case actionTypes.FETCH_CREDITS_RESULT_FAILURE:
         return Object.assign({}, ...[state], {});
      case actionTypes.EXPORT_CREDITS_RESULT_CSV_SUCCESS:
         return Object.assign({}, ...[state], { creditResultExportRecords: action.exportCreditsResult });
      case actionTypes.EXPORT_CREDITS_RESULT_CSV_FAILURE:
         return Object.assign({}, ...[state], {});
      default:
         return state;
   }
};

